module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe-wrap"
  }, [_c('div', {
    staticClass: "swipe",
    attrs: {
      "id": "leftbrand-swiper2"
    }
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow,
      "height": 300,
      "width": 300
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('CarouselItem', {
      key: item.key
    }, [_c('router-link', {
      attrs: {
        "to": item.to,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "scrollLoading",
      attrs: {
        "src": item.atturl,
        "height": "300px",
        "alt": item.aname,
        "width": "300px",
        "target": "_blank"
      }
    })])], 1)
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cad216e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/brand/left-ad/ad-list.vue
// module id = 1579
// module chunks = 1